import ImagePreview from "./image";
import { getThumbnailUrlForMakoImages } from "../../apiUtils";

export default function TiffImagePreview({ src }: { src: string }) {
  const thumbnailUrl = getThumbnailUrlForMakoImages({ url: src });
  return <ImagePreview src={thumbnailUrl ?? src} />;
}
